import { TeamMemberReference, ITeamMember } from './TeamMemberStore';
import { flow, getParent, getSnapshot, types } from 'mobx-state-tree';
import { DateTime } from './DateTime';

export const ResponsibleMixin = types
  .model({
    responsible: types.array(types.late(() => TeamMemberReference)),
  })
  .actions((self) => ({
    removeResponsible: flow(function* removeContact(user: ITeamMember) {
      const index = self.responsible.findIndex(
        (c: any) => c && c.id === user.id
      );
      if (index > -1) {
        const [removed] = self.responsible.splice(index, 1);
        // Parrent is TaskStore
        try {
          const parent = getParent(self, 2) as any;
          yield parent.updateItem(self as any, {
            responsible: getSnapshot(self).responsible,
          });
        } catch {
          // Undo...
          self.responsible.splice(index, 0, removed);
        }
      }
    }),
    addResponsible: flow(function* addContact(user: ITeamMember) {
      const index = self.responsible.findIndex((c) => c && c.id === user.id);
      if (index === -1) {
        const parent = getParent(self, 2) as any;
        self.responsible.push(user);
        try {
          yield parent.updateItem(self as any, {
            responsible: getSnapshot(self).responsible,
          });
        } catch {
          self.responsible.pop();
        }
      }
    }),
  }));

export const CommomMixin = types.model({
  reference: types.maybeNull(types.string),
  description: types.maybeNull(types.string),
  tags: types.array(types.string),
  created_at: types.optional(DateTime, () => new Date()),
});
